import { contractDate } from "./planningDates";
const id = value => String(value?._id || value || "");
export function planningRequests(requests, contracts = []) {
 return requests.flatMap(request => {
  const dates = request.contractType === "vacation" && request.placementDetails?.dates?.length
   ? request.placementDetails.dates.map(row=>({start:row.dateDebut,end:row.dateDebut,startHour:row.startHour,endHour:row.endHour}))
   : [{start:request.startDate,end:request.endDate || request.startDate,startHour:request.startHourString,endHour:request.endHourString}];
  return dates.filter(period=>contractDate(period.start) && !contracts.some(contract=>{
   const exact = id(request.orderId) && id(contract.order || contract.orderId)===id(request.orderId) && id(contract.candidate)===id(request.candidate);
   const tempo = request.client?.pld && request.candidate?.pld && String(contract.IdClient)===String(request.client.pld) && String(contract.IdInterimaire)===String(request.candidate.pld);
   if (!exact && !tempo) return false;
   const start=contractDate(contract.DateDebut || contract.startDate);
   const end=contractDate(contract.DateFinMission || contract.DateFin || contract.endDate) || start;
   return start && end && start<=contractDate(period.start) && end>=contractDate(period.end);
  })).map((period,index)=>({
   _id:`request-${request._id}-${index}`,requestId:request._id,isContractRequest:true,status:"Demandé",
   contractType:request.contractType,client:request.client,candidate:request.candidate,order:request.orderId,
   IdClient:request.client?.pld || id(request.client),IdInterimaire:request.candidate?.pld || id(request.candidate),
   RaisonSociale:request.client?.companyName || request.client?.denomination || "Client",
   NomPrenom:[request.candidate?.firstname,request.candidate?.lastname].filter(Boolean).join(" ") || "Candidat",
   Qualification:request.clientQualification?.TxtQualification || "",
   DateDebut:period.start,DateFin:period.end,HeureDebut:period.startHour,HeureFin:period.endHour,
   NumeroContrat:`Demande ${String(request._id).slice(-6).toUpperCase()}`,
  }));
 });
}
